import { PermissionType } from "@shared/api/authentication/types"

export const APP_NAME_COMMON = "Carbon Bank"
export const APP_NAME_MRV = "MRV"
export const APP_NAME_ADMIN = "Admin"
export const DNV_ASSURANCE_URL = "https://www.dnv.de/assurance/"

/**
 * Roles allowed to flag/resolve product allocations (single & bulk) and to see
 * the related action buttons. Admins may view product-allocation pages but must
 * not perform these actions, so they are intentionally excluded here.
 */
export const PRODUCT_ALLOCATION_ACTION_PERMISSIONS: PermissionType[] = [
	PermissionType.MrvAnnualAssurer,
	PermissionType.MrvCoordinator,
]

/**
 * Roles allowed to adjust the carbon balance of a product allocation and to see
 * the related alert/action button. Restricted to the MRV Coordinator role only.
 */
export const BALANCE_ADJUSTMENT_PERMISSIONS: PermissionType[] = [
	PermissionType.MrvCoordinator,
]

/**
 * Roles allowed to adjust a plant's carbon settings and balance (carbon account
 * settings, carbon buffer settings, plant balance chart) and to see the related
 * "Adjust" buttons. Restricted to the MRV Coordinator role only.
 */
export const PLANT_ADJUSTMENT_PERMISSIONS: PermissionType[] = [
	PermissionType.MrvCoordinator,
]
